import { useState } from 'react'
import { FaFileCirclePlus } from 'react-icons/fa6'
import Input from '../../../../shared/components/form/input'
import FormRecordNextByUser from './FormRecordNextByUser'
import './formRegisterInfo.css'
/* Function */
import { monthToNominal, monthToNominalShort, monthYear } from "../../Functions/Date"
import FormRecord from './FormRecord'


function FormRegisterInfo({ title, NextToDoByUser, lastDid, NextToDo, handleOnSubmit , permission_create}) {

    const [modalNewRecord, setModalNewRecord] = useState(false)
    const [newRecord, setNewRecord] = useState()


    const submit = async (data) => {

        let response = await handleOnSubmit(data)
        if(response === "success"){
            setModalNewRecord(false)

        }


    }

    return (
        <div>
            <div className='form-register-info-box'>
                <span className='form-register-info-title'>{title}</span>
                <div className='form-register-info-box-box'>
                    <div className='form-register-info-box-record'>
                        <span className='form-register-info-label'>Última realizada</span>
                        <span className='form-register-info-value'>{lastDid ? monthYear(lastDid) : "-------"}</span>
                    </div>
                    <div className='form-register-info-box-record'>
                        <span className='form-register-info-label'>Próxima realizada</span>
                        <span className='form-register-info-value'>{NextToDo ? monthYear(NextToDo) : "-------"}</span>
                    </div>
                    {permission_create &&
                        <button className='form-register-info-new-btn' onClick={() => { setModalNewRecord(true) }}>
                            <FaFileCirclePlus size={14} /> Novo Registro
                        </button>
                    }
                </div>

            </div>

            <div>

                {modalNewRecord &&
                    <>
                    {NextToDoByUser ?
                    <FormRecordNextByUser title={title} handleOnSubmit={submit} closeModal={() => {setModalNewRecord(false)}}/>
                    :
                    <FormRecord title={title} handleOnSubmit={submit} closeModal={() => {setModalNewRecord(false)}} />
                    }
                    </>
                }
            </div>



        </div>
    )
}

export default FormRegisterInfo